import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { AGVIEW_SECRET } from 'app/app.constants';

@Component({
  selector: 'app-autenticacao-modal',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './autenticacao-modal.component.html',
  styleUrl: './autenticacao-modal.component.css'
})
export class AutenticacaoModalComponent implements OnInit { 
  @ViewChild('imgSenha', { read: ViewContainerRef, static: true })
  containerSenha!: ViewContainerRef;
  @ViewChild('input', { read: ViewContainerRef, static: true })
  containerInput!: ViewContainerRef;
  @Output() enviarDados: EventEmitter<boolean> = new EventEmitter<boolean>();
  public tipoCampo: 'text' | 'password' = 'password';
  public senhaAtual: number = 0;
  public senhaIncorreta: boolean = false;
  
  ngOnInit(): void {
    this.senhaAtual = Math.floor(Math.random() * (9999 - 1001 + 1)) + 1001;
  }

  public alternarTipoCampo(): void {
    if(this.tipoCampo == 'text') {
      this.containerSenha.element.nativeElement.src = 'assets/agview-connect/visivel.png';
      this.tipoCampo = 'password';
    } else {
      this.containerSenha.element.nativeElement.src = 'assets/agview-connect/oculto.png';
      this.tipoCampo = 'text';
    }
  }

  public validarSenha(): void {
    const valorUsuario: string = this.containerInput.element.nativeElement.value;
    if(valorUsuario){
      const autorizado: boolean = Number(valorUsuario) == Number(AGVIEW_SECRET) * this.senhaAtual;
      if (autorizado) {
        this.senhaIncorreta = false;
        this.enviarDados.emit(true);
        this.resetarDados();
        
      } else {
        this.senhaIncorreta = true;
      }
    }
  }

  public resetarDados(): void {
    this.senhaIncorreta = false;
    this.containerInput.element.nativeElement.value = '';
    this.ngOnInit();
  }
  
  public cancelarAlteracoes(): void {
    this.resetarDados();
    this.enviarDados.emit(false);
  }
}
